import { useCallback } from "react"
import { useDispatch } from "react-redux"
import { useEffectOnce } from "react-use"
import { actions } from "~/redux/process"
import { auth } from "~/redux/state/auth"
import { settings } from "~/redux/state/settings"
import { generateDeviceToken, getLocalStorageItem } from "~/services/Utils"
import { useSettings } from "./useSettings"

export const useBootstrapApplication = () => {
  const dispatch = useDispatch()
  const {
    settings: { isUserAccountEnabled, loggingMode },
  } = useSettings()

  const boot = useCallback(() => {
    if (window) {
      window.debug = loggingMode !== "disabled"
    }

    // restore checkout data from local storage if available
    dispatch(actions.restoreCheckoutData())
    dispatch(actions.restoreCartData())

    // Generate device token
    const deviceToken = getLocalStorageItem(
      "deviceToken",
      generateDeviceToken()
    )

    // Register settings
    dispatch(settings.actions.updateDeviceToken(deviceToken))

    if (isUserAccountEnabled) {
      // Restore user session if possible
      dispatch(auth.actions.loginSilently())
    }
  }, [dispatch, isUserAccountEnabled, loggingMode])

  useEffectOnce(boot)
}
